module.exports = __webpack_public_path__ + "static/img/13.98f29f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/13.jpg
// module id = RVyg
// module chunks = 1